import { useState } from "react";

import {
  buildAttorneyPayload,
  buildAttorneyValues,
  isAttorneyDirty,
} from "../helper/attorney";
import { normalizeNullableCurrencyInput } from "../helper/caseForms";

import useSettlementCaseForm from "./useSettlementCaseForm";

export default function useAttorneySection({ caseDetail }) {
  const {
    formValues,
    setFormValues,
    isDirty,
    isEditing,
    setIsEditing,
    isSaving,
    canEditCaseSettlement,
    handleCancel: handleBaseCancel,
    handleSave: handleBaseSave,
  } = useSettlementCaseForm({
    caseDetail,
    buildValues: buildAttorneyValues,
    buildPayload: buildAttorneyPayload,
    isDirtyCheck: isAttorneyDirty,
  });
  const [isFeeEditing, setIsFeeEditing] = useState(false);
  const [isCostEditing, setIsCostEditing] = useState(false);

  const handleFieldChange = (fieldName, value) => {
    if (!canEditCaseSettlement) {
      return;
    }

    setFormValues((prev) => ({
      ...prev,
      [fieldName]: normalizeNullableCurrencyInput(value),
    }));
  };

  const handleBeginFeeEdit = () => {
    if (!canEditCaseSettlement) {
      return;
    }

    setIsEditing(true);
    setIsFeeEditing(true);
  };

  const handleBeginCostEdit = () => {
    if (!canEditCaseSettlement) {
      return;
    }

    setIsEditing(true);
    setIsCostEditing(true);
  };

  const handleClearFee = () => {
    if (!canEditCaseSettlement) {
      return;
    }

    setFormValues((prev) => ({
      ...prev,
      lawyerSettlementAmount: "",
    }));
  };

  const handleClearCost = () => {
    if (!canEditCaseSettlement) {
      return;
    }

    setFormValues((prev) => ({
      ...prev,
      lawyerSettlementCosts: "",
    }));
  };

  const handleCancel = () => {
    handleBaseCancel();
    setIsFeeEditing(false);
    setIsCostEditing(false);
  };

  const handleSave = async () => {
    await handleBaseSave(() => {
      setIsFeeEditing(false);
      setIsCostEditing(false);
    });
  };

  return {
    formValues,
    isDirty,
    isEditing,
    isFeeEditing,
    isCostEditing,
    isSaving,
    canEditCaseSettlement,
    handleFieldChange,
    handleBeginFeeEdit,
    handleBeginCostEdit,
    handleClearFee,
    handleClearCost,
    handleCancel,
    handleSave,
  };
}
